
import Dexie, { Table as DexieTable } from 'dexie';
import { StockItem, Product, Table, TaxRate, Transaction, ZReport, Staff, ExpenseCategory, ExpenseTransaction, ModifierGroup, Section, ShiftReport, Category, Customer, CustomerAccountMovement } from './types';

export class CoffeePOSDatabase extends Dexie {
  stockItems!: DexieTable<StockItem, number>;
  products!: DexieTable<Product, number>;
  restaurantTables!: DexieTable<Table, number>;
  taxRates!: DexieTable<TaxRate, number>;
  transactions!: DexieTable<Transaction, string>;
  zReports!: DexieTable<ZReport, string>;
  shiftReports!: DexieTable<ShiftReport, string>;
  settings!: DexieTable<{ key: string; value: any }, string>;
  staff!: DexieTable<Staff, number>;
  expenseCategories!: DexieTable<ExpenseCategory, number>;
  expenses!: DexieTable<ExpenseTransaction, number>;
  modifierGroups!: DexieTable<ModifierGroup, number>;
  sections!: DexieTable<Section, number>;
  roles!: DexieTable<any, number>;
  categories!: DexieTable<Category, string>; // New table for dynamic categories
  customers!: DexieTable<Customer, string>; // CRM
  customerAccountMovements!: DexieTable<CustomerAccountMovement, string>;
  syncStack!: DexieTable<SyncItem, number>;
  notifications!: DexieTable<any, number>;

  constructor() {
    super('CoffeePOSDB');
    (this as any).version(5).stores({
      stockItems: '++id, name',
      products: '++id, name, category',
      restaurantTables: '++id',
      taxRates: '++id',
      transactions: 'id, date, staffId',
      zReports: 'id, date',
      shiftReports: 'id, staffId, endTime',
      settings: 'key',
      staff: '++id, name',
      expenseCategories: '++id, name',
      expenses: '++id, date, categoryId',
      modifierGroups: '++id, name',
      sections: '++id, name',
      roles: '++id, name',
      categories: 'id, name, sortOrder', // Schema for categories
      customers: 'id, name, phone', // CRM
      customerAccountMovements: 'id, customerId, type, date, transactionId',
      syncStack: '++id, status, type' // For offline sync queue
    });
    // v6: adds retryCount field to SyncItem (non-indexed, no index change needed)
    (this as any).version(6).stores({
      syncStack: '++id, status, type'
    });
    // v7: bildirimlerin kalıcı saklanması için notifications tablosu
    (this as any).version(7).stores({
      notifications: 'id, timestamp'
    });
  }
}

export interface SyncItem {
  id?: number;
  type:
  | 'product'
  | 'stockItem'
  | 'category'
  | 'staff'
  | 'setting'
  | 'qrsetting'
  | 'modifierGroup'
  | 'role'
  | 'zReport'
  | 'shiftReport'
  | 'expenseCategory'
  | 'expense'
  | 'taxRate'
  | 'customer'
    | 'customerAccountMovement'
  | 'table'
  | 'section'
  | 'transaction';
  action: 'create' | 'update' | 'delete';
  data: any;
  status: 'pending' | 'synced' | 'failed';
  timestamp: number;
  retryCount?: number;
}

export const localDb = new CoffeePOSDatabase();
export const db = localDb; // Alias for Dexie (used by DataContext, SyncContext)
